import styled from 'styled-components';
import {
  darkBlueBackground,
  white,
  yellow,
  green,
  lightGrey,
  darkGrey,
} from './colors';

export const Backdrop = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${darkBlueBackground};
  border-radius: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const PlayName = styled.div`
  color: ${white};
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: ${white};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  & > svg {
    width: 20px;
    height: 20px;
  }
`;

export const PoolWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 16px 16px 70px 16px;
  min-height: 200px;
`;

export const ControlsBar = styled.div<{ $frameStripOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  position: absolute;
  bottom: ${({ $frameStripOpen }) => ($frameStripOpen ? '130px' : '0')};
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  transition: bottom 0.3s ease;
`;

export const ControlBtn = styled.button<{
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $isActive }) =>
    $isActive ? 'rgba(255, 255, 255, 0.15)' : 'none'};
  border: none;
  color: ${({ $isDisabled }) => ($isDisabled ? darkGrey : white)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};

  &:hover {
    background: ${({ $isDisabled }) =>
      $isDisabled ? 'none' : 'rgba(255, 255, 255, 0.1)'};
  }

  & > svg {
    width: 20px;
    height: 20px;
  }

  -webkit-tap-highlight-color: transparent;
`;

export const ProgressText = styled.span`
  color: ${lightGrey};
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  min-width: 44px;
  text-align: center;
  user-select: none;
`;

export const ProgressBarContainer = styled.div`
  flex: 1;
  max-width: 200px;
  height: 4px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => `${$progress}%`};
  background: ${green};
  border-radius: 2px;
  transition: width 0.1s linear;
`;

export const ModeToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  padding-left: 12px;
  //border-left: 1px solid rgba(255, 255, 255, 0.15);
  position: absolute;
  right: 20px;
`;

export const ModeLabel = styled.span`
  color: ${darkGrey};
  font-size: 10px;
  text-align: right;
  line-height: 1.2;
`;

export const ModeButton = styled.button<{ $isActive: boolean }>`
  padding: 4px 12px;
  border-radius: 10px;
  border: none;
  background: ${({ $isActive }) => ($isActive ? yellow : darkBlueBackground)};
  color: ${({ $isActive }) => ($isActive ? '#000' : '#fff')};
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
  margin-right: 4px;
  margin-left: 3px;
  outline: none;
  border: 1px solid
    ${({ $isActive }) => ($isActive ? yellow : 'rgba(255, 255, 255, 0.2)')};
`;

export const FrameStripContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 10px 16px;
  overflow-x: auto;
  overflow-y: hidden;
  height: 110px;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.7);
  transform: translateY(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  transition: transform 0.3s ease;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
  }
`;

export const FrameStripToggleBtn = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $isOpen }) =>
    $isOpen ? 'rgba(255, 255, 255, 0.15)' : 'none'};
  border: none;
  color: ${white};
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition:
    background 0.2s,
    transform 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  & > svg {
    width: 20px;
    height: 20px;
    transform: ${({ $isOpen }) =>
      $isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
  }
`;

export const FrameStripItem = styled.div<{ $isActive: boolean }>`
  flex-shrink: 0;
  width: 130px;
  height: 80px;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid ${({ $isActive }) => ($isActive ? white : 'transparent')};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.6)};
  transform: ${({ $isActive }) => ($isActive ? 'scale(1.04)' : 'scale(1)')};
  transition: all 0.15s ease;
  position: relative;
  display: flex;
  justify-content: center;

  &:hover {
    opacity: 1;
    border-color: ${({ $isActive }) =>
      $isActive ? white : 'rgba(255, 255, 255, 0.4)'};
  }
`;

export const FrameStripLabel = styled.span`
  display: block;
  text-align: center;
  color: ${lightGrey};
  font-size: 10px;
  margin-top: 2px;
  user-select: none;
  position: absolute;
  bottom: 3px;
  width: 100%;
`;
